<template>
  <div :class="[section.options.content.image.customClass, {'element-hidden': !visability('image')}]">
    <highliter
      v-model="section.name"
      :disable-toolbar="section.options.content.image.disableToolbar"
      :dublicate="section"
      :dublicate-deep="parentUID"
      active-class="z-100"
      class="highlight-element"
      section-type="element"
      @delete="$emit('delete')"
      @dublicate="$emit('dublicate')"
      @favorite="$emit('favorite', $el)"
      @flow="handleFlow"
      @move-to="to => $emit('move-to', to)"
      @add-subject="$emit('add-subject')"
      @click.stop.native="sectionSettings('image')"
    >
      <TemplateV2 :section="section">
        <image-fit-v2
          :customs="section.options.content.image"
        />
        <slot />
      </TemplateV2>
    </highliter>
  </div>
</template>

<script>
import SectionMixin from '@builder/components/mixins/SectionMixin'
import Highliter from '@builder/components/builder/utils/Highliter'
import ImageFitV2 from '../../../../utils/ImageFitV2'
import TemplateV2 from './TemplateV2'

export default {
  name: 'ElImageV2',

  components: {TemplateV2, ImageFitV2, Highliter},

  mixins: [SectionMixin]
}
</script>
